import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class BackToDraft extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.BACK_TO_DRAFT, ActionEnum.CONFIRM_BACK_TO_DRAFT]);
  }
}

export default BackToDraft;
